import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import themes from "../theme/data/reducer";
import app from "../containers/data/reducer";
import services from "../screens/Services/data/reducer";
import serviceCenters from "../screens/ServiceCenters/data/reducer";
import entityZoomed from "../screens/EntityZoomed/data/reducer";
import channelZoomed from "../screens/ChannelZoomed/data/reducer";
import sectorZoomed from "../screens/SectorZoomed/data/reducer";
import tweets from "../components/TweetArea/data/reducer";

export default history =>
  combineReducers({
    app,
    router: connectRouter(history),
    themes,
    services,
    serviceCenters,
    entityZoomed,
    tweets,
    channelZoomed,
    sectorZoomed
  });
